import { Path } from 'slate'
import { FieldTypes } from '../../constants'
import { FontId } from '../../editor/types'
import { Field, FieldMap, ListField } from './fields'
import { Form } from './form'

export interface Shortcut {
  children?: never
  itemFields?: never
  info?: never
  name: string
  shortcut: true
  // id: string
  // path: string
  type: FieldTypes
}

export interface AttachmentShortcutFontStyle {
  family?: FontId
  size?: number
  color?: string
  bold?: boolean
  italic?: boolean
  underline?: boolean
}

export interface AttachmentShortcutStyle {
  font?: AttachmentShortcutFontStyle
  backgroundColor?: string
}

export interface AttachmentShortcut extends Shortcut {
  id: string
  path: string
  style?: AttachmentShortcutStyle
}

export interface ShortcutMap {
  itemFields?: never
  info?: never
  shortcut: true
  name: string
  children: Record<string, Shortcut | ShortcutMap>
  isTemplateFieldMap?: never
  isTemplateField?: never
}

export type TemplateField = Field & {
  isTemplateField: true
  isCreateTemplateField?: never
}

export interface CreateTemplateField {
  info?: never
  children?: never
  isCreateTemplateField: true
  isTemplateField?: never
}

export const isCreateTemplateField = (
  v: FieldMap | ShortcutMap | TemplateFieldMap | Field | Shortcut | ListField | CreateTemplateField,
): v is CreateTemplateField => 'isCreateTemplateField' in v

export type TemplateNodeField<F extends Field = Field> = F & {
  id: string
  path: Path
}

export type TemplateNodeFieldMap = Omit<FieldMap, 'children'> & {
  children: Record<string, TemplateNodeField>
}

export type TemplateFieldMap = Omit<FieldMap, 'children'> & {
  isTemplateFieldMap: true
  children: Record<string, TemplateField | CreateTemplateField>
}

export const isShortcutMap = (
  v: Shortcut | ShortcutMap | Form | FieldMap | Field | TemplateFieldMap,
): v is ShortcutMap => 'children' in v && 'shortcut' in v

export const isTemplateFieldMap = (
  v: TemplateFieldMap | FieldMap | Field | ListField | Form | Shortcut | ShortcutMap,
): v is TemplateFieldMap => 'children' in v && 'isTemplateFieldMap' in v

export const isTemplateField = (v: Field | TemplateField | Shortcut): v is TemplateField =>
  'isTemplateField' in v

export const isTemplateNodeField = (v: Field | TemplateNodeField): v is TemplateNodeField =>
  'id' in v && 'path' in v
